import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { actionCreators, getHeight, getIsUpdatingAnamnesis } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => ({
	...mapParentStateToProps(state, props),
	currentStep: ANAMNESIS_VIEWS.DETERMINE_SIZE,
	value: getHeight(state),
	isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
	introTitle: i18n('react.impulsCoach.components.anamnesis.determineHeight.introTitle'),
	introText: i18n('react.impulsCoach.components.anamnesis.determineHeight.introText'),
	title: i18n('react.impulsCoach.components.anamnesis.determineHeight.title'),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type DetermineHeightContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
